/**
 * ShopRedirect — M4.1: /shop ya no es pantalla propia; redirige a la
 * pestaña Tienda del Feed preservando ?tab=courses y ?category.
 */
import { Navigate, useSearchParams } from 'react-router-dom';

export default function ShopRedirect() {
  const [sp] = useSearchParams();
  const p = new URLSearchParams({ tab: 'shop' });
  if (sp.get('tab') === 'courses') p.set('shop_tab', 'courses');
  if (sp.get('category')) p.set('category', sp.get('category'));
  return <Navigate to={`/feed?${p.toString()}`} replace />;
}
